module.exports = __webpack_public_path__ + "static/media/vanessa-narrow.906692a1.png";